import { H3 } from 'components/common/H3'
import styled from 'styled-components'

interface Props {
  expired?: boolean
  isHours?: boolean
}

export const BannerWrapper = styled.div<Props>`
  background-color: ${({ isHours, expired, theme }) =>
    isHours
      ? theme.discountBanner.warn.background
      : expired
      ? theme.discountBanner.error.background
      : theme.discountBanner.success.background};

  color: ${({ isHours, expired, theme }) =>
    isHours
      ? theme.discountBanner.warn.colour
      : expired
      ? theme.discountBanner.error.colour
      : theme.discountBanner.success.colour};

  display: flex;
  justify-content: center;
  padding-top: 12px;
  padding-bottom: 12px;
`

export const BannerText = styled(H3)`
  margin: 0;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`
